import ApiServices from '@/services/uteis/ApiServices.js';
import route from '@/libs/endPoint/base/EscolasRoutes';

class EscolasServices {
  async load(params) {
    try {
      const url = route.main;
      const { data } = await ApiServices.get(url, params);
      return data;
    } catch (error) {
      console.error('Erro ao buscar dados da inscrição:', error);
      throw error;
    }
  }
}
export default new EscolasServices();
